module.exports = __webpack_public_path__ + "media/images/about-us/works/Concierge_and_Help_Desk_Line-f72bf545852531047d0a579e2d092d48.png";